import { GetterTree } from 'vuex'
import _groupBy from 'lodash/groupBy'
import _lowerCase from 'lodash/lowerCase'
import _property from 'lodash/property'
import _keys from 'lodash/keys'

import { BooksState } from './types'
import { RootState } from '../types'
import { Book, GuidePrice, Condition } from '@/types'

export const getters: GetterTree<BooksState, RootState> = {
  getSearchKeyword(state): string {
    return state.searchKeyword
  },
  getBestBook(state): Book | null {
    return state.bestBook
  },
  getActiveGuidePrice(state): GuidePrice | null {
    return state.activeGuidePrice
  },
  getConditions(state): any {
    return (state.conditions || []).filter(c => _lowerCase(c.name) === _lowerCase(c.conditionType))
  },
  getConditionsGroupByType(state): any {
    // { conditionType: Conidtion[] }
    const temp = _groupBy(state.conditions || [], _property('conditionType'))
    const keys = _keys(temp)
    for (const k of keys) {
      if (temp[k].length > 1) {
        temp[k] = temp[k].filter(c => _lowerCase(c.name) !== _lowerCase(c.conditionType))
      }
    }
    return temp
  },
}
